import { render, staticRenderFns } from "./BusinessReportViewer.vue?vue&type=template&id=485c901a&scoped=true"
import script from "./BusinessReportViewer.vue?vue&type=script&lang=js"
export * from "./BusinessReportViewer.vue?vue&type=script&lang=js"
import style0 from "./BusinessReportViewer.vue?vue&type=style&index=0&id=485c901a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485c901a",
  null
  
)

export default component.exports